// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/connector/v2/asset.proto" (package "c1.connector.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.connector.v2.AssetRef
 */
export interface AssetRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.connector.v2.AssetServiceGetAssetRequest
 */
export interface AssetServiceGetAssetRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.AssetRef asset = 1
     */
    asset?: AssetRef;
}
/**
 * @generated from protobuf message c1.connector.v2.AssetServiceGetAssetResponse
 */
export interface AssetServiceGetAssetResponse {
    /**
     * @generated from protobuf oneof: msg
     */
    msg: {
        oneofKind: "metadata";
        /**
         * @generated from protobuf field: c1.connector.v2.AssetServiceGetAssetResponse.Metadata metadata = 1
         */
        metadata: AssetServiceGetAssetResponse_Metadata;
    } | {
        oneofKind: "data";
        /**
         * @generated from protobuf field: c1.connector.v2.AssetServiceGetAssetResponse.Data data = 2
         */
        data: AssetServiceGetAssetResponse_Data;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.connector.v2.AssetServiceGetAssetResponse.Metadata
 */
export interface AssetServiceGetAssetResponse_Metadata {
    /**
     * @generated from protobuf field: string content_type = 1
     */
    contentType: string;
}
/**
 * @generated from protobuf message c1.connector.v2.AssetServiceGetAssetResponse.Data
 */
export interface AssetServiceGetAssetResponse_Data {
    /**
     * @generated from protobuf field: bytes data = 1
     */
    data: Uint8Array;
}
// @generated message type with reflection information, may provide speed optimized methods
class AssetRef$Type extends MessageType<AssetRef> {
    constructor() {
        super("c1.connector.v2.AssetRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<AssetRef>): AssetRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AssetRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssetRef): AssetRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssetRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AssetRef
 */
export const AssetRef = new AssetRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssetServiceGetAssetRequest$Type extends MessageType<AssetServiceGetAssetRequest> {
    constructor() {
        super("c1.connector.v2.AssetServiceGetAssetRequest", [
            { no: 1, name: "asset", kind: "message", T: () => AssetRef, options: { "validate.rules": { message: { required: true } } } }
        ]);
    }
    create(value?: PartialMessage<AssetServiceGetAssetRequest>): AssetServiceGetAssetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AssetServiceGetAssetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssetServiceGetAssetRequest): AssetServiceGetAssetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.AssetRef asset */ 1:
                    message.asset = AssetRef.internalBinaryRead(reader, reader.uint32(), options, message.asset);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssetServiceGetAssetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.AssetRef asset = 1; */
        if (message.asset)
            AssetRef.internalBinaryWrite(message.asset, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AssetServiceGetAssetRequest
 */
export const AssetServiceGetAssetRequest = new AssetServiceGetAssetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssetServiceGetAssetResponse$Type extends MessageType<AssetServiceGetAssetResponse> {
    constructor() {
        super("c1.connector.v2.AssetServiceGetAssetResponse", [
            { no: 1, name: "metadata", kind: "message", oneof: "msg", T: () => AssetServiceGetAssetResponse_Metadata },
            { no: 2, name: "data", kind: "message", oneof: "msg", T: () => AssetServiceGetAssetResponse_Data }
        ]);
    }
    create(value?: PartialMessage<AssetServiceGetAssetResponse>): AssetServiceGetAssetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.msg = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AssetServiceGetAssetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssetServiceGetAssetResponse): AssetServiceGetAssetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.AssetServiceGetAssetResponse.Metadata metadata */ 1:
                    message.msg = {
                        oneofKind: "metadata",
                        metadata: AssetServiceGetAssetResponse_Metadata.internalBinaryRead(reader, reader.uint32(), options, (message.msg as any).metadata)
                    };
                    break;
                case /* c1.connector.v2.AssetServiceGetAssetResponse.Data data */ 2:
                    message.msg = {
                        oneofKind: "data",
                        data: AssetServiceGetAssetResponse_Data.internalBinaryRead(reader, reader.uint32(), options, (message.msg as any).data)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssetServiceGetAssetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.AssetServiceGetAssetResponse.Metadata metadata = 1; */
        if (message.msg.oneofKind === "metadata")
            AssetServiceGetAssetResponse_Metadata.internalBinaryWrite(message.msg.metadata, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.AssetServiceGetAssetResponse.Data data = 2; */
        if (message.msg.oneofKind === "data")
            AssetServiceGetAssetResponse_Data.internalBinaryWrite(message.msg.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AssetServiceGetAssetResponse
 */
export const AssetServiceGetAssetResponse = new AssetServiceGetAssetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssetServiceGetAssetResponse_Metadata$Type extends MessageType<AssetServiceGetAssetResponse_Metadata> {
    constructor() {
        super("c1.connector.v2.AssetServiceGetAssetResponse.Metadata", [
            { no: 1, name: "content_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<AssetServiceGetAssetResponse_Metadata>): AssetServiceGetAssetResponse_Metadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.contentType = "";
        if (value !== undefined)
            reflectionMergePartial<AssetServiceGetAssetResponse_Metadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssetServiceGetAssetResponse_Metadata): AssetServiceGetAssetResponse_Metadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string content_type */ 1:
                    message.contentType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssetServiceGetAssetResponse_Metadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string content_type = 1; */
        if (message.contentType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.contentType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AssetServiceGetAssetResponse.Metadata
 */
export const AssetServiceGetAssetResponse_Metadata = new AssetServiceGetAssetResponse_Metadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssetServiceGetAssetResponse_Data$Type extends MessageType<AssetServiceGetAssetResponse_Data> {
    constructor() {
        super("c1.connector.v2.AssetServiceGetAssetResponse.Data", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "0", maxLen: "1048576" } } } }
        ]);
    }
    create(value?: PartialMessage<AssetServiceGetAssetResponse_Data>): AssetServiceGetAssetResponse_Data {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<AssetServiceGetAssetResponse_Data>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssetServiceGetAssetResponse_Data): AssetServiceGetAssetResponse_Data {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes data */ 1:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssetServiceGetAssetResponse_Data, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes data = 1; */
        if (message.data.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AssetServiceGetAssetResponse.Data
 */
export const AssetServiceGetAssetResponse_Data = new AssetServiceGetAssetResponse_Data$Type();
/**
 * @generated ServiceType for protobuf service c1.connector.v2.AssetService
 */
export const AssetService = new ServiceType("c1.connector.v2.AssetService", [
    { name: "GetAsset", serverStreaming: true, options: {}, I: AssetServiceGetAssetRequest, O: AssetServiceGetAssetResponse }
]);
